"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMeasureElement", {
    enumerable: true,
    get: ()=>useMeasureElement
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _reactUtilities = require("@fluentui/react-utilities");
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactSharedContexts = require("@fluentui/react-shared-contexts");
function useMeasureElement() {
    const [width, setWidth] = _react.useState(0);
    const container = _react.useRef(undefined);
    const { targetDocument  } = (0, _reactSharedContexts.useFluent_unstable)();
    // the handler for resize observer
    const handleResize = _react.useCallback(()=>{
        var _container_current;
        const containerWidth = (_container_current = container.current) === null || _container_current === void 0 ? void 0 : _container_current.getBoundingClientRect().width;
        setWidth(containerWidth || 0);
    }, []);
    // Keep the reference of ResizeObserver in the state, as it should live through renders
    const [resizeObserver] = _react.useState((0, _reactUtilities.canUseDOM)() ? new ResizeObserver(handleResize) : undefined);
    const measureElementRef = _react.useCallback((el)=>{
        if (!targetDocument || !resizeObserver) {
            return;
        }
        // cleanup previous container
        if (container.current) {
            resizeObserver.unobserve(container.current);
            container.current.remove();
        }
        if (el) {
            container.current = targetDocument.createElement('div');
            el.insertAdjacentElement('beforebegin', container.current);
            resizeObserver.observe(container.current);
            handleResize();
        }
    }, [
        targetDocument,
        resizeObserver,
        handleResize
    ]);
    _react.useEffect(()=>{
        return ()=>{
            return resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        };
    }, [
        resizeObserver
    ]);
    return {
        width,
        measureElementRef
    };
} //# sourceMappingURL=useMeasureElement.js.map

//# sourceMappingURL=useMeasureElement.js.map